export function getModalOffset(screenWidth: number) {
  return screenWidth > 768 ? '15dvh' : '';
}